
import { defineComponent, ref, onMounted } from "vue";
import router from "@/router";
import store from "@/store";
import NativeClient from "@/client/native-client";
import { convertRemToPx } from "@/utils/common-utils";
import { LoadPantryCameraImage, PantryCameraImageResult, PantryCameraImage } from "@/types/common";
import { useApiErrorHandler } from "@/use/use-api-error-handler";
import { useApiErrorDialog } from "@/use/use-api-error-dialog";
import CommonDesignDialog from "@/components/common/CommonDesignDialog.vue";
export default defineComponent({
  name: "PantryImageZoomPage",
  components: {
    CommonDesignDialog
  },
  metaInfo: {
    meta: [
      { name: 'viewport', content: 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=5.0' }
    ]
  },
  setup() {
    const ERROR_BUTTON_LABEL = "OK";
    const width = ref(0);
    const height = ref(0);
    const {
      handleApiError,
      getApiErrorTitle,
      getApiErrorMessage,
    } = useApiErrorHandler();
    const { closeDialog } = useApiErrorDialog();
    const getFileName = () => {
      const fileName = String(router.currentRoute.value.query['fileName']);
      NativeClient.sendDebugLog(
        "PantryInferenceImageZoomPage getFileName fileName=" + fileName
      );
      let result = "";
      if (fileName != "") {
        result = decodeURIComponent(fileName);
      }
      return result;
    };
    const fileName = getFileName();
    const image = ref<HTMLImageElement>();
    NativeClient.sendDebugLog(
      "PantryInferenceImageZoomPage fileName=" + fileName
    );
    const setImage = (base64Data: string, width: number, height: number) => {
      NativeClient.sendDebugLog(
        "PantryInferenceImageZoomPage setImage"
      );
      if (image.value == undefined) {
        return;
      }
      image.value.src = "data:image/jpeg;base64," + base64Data;
      image.value.decoding = "async";
      image.value.onload = function() {
        if (image.value == undefined) {
          return;
        }
        NativeClient.sendDebugLog(
          "PantryInferenceImageZoomPage drawImageData loaded width=" +
            width +
            " height=" +
            height
        );
        NativeClient.sendDebugLog(
          "PantryInferenceImageZoomPage drawImageData loaded image.width=" +
            image.value.naturalWidth +
            " image.height=" +
            image.value.naturalHeight
        );
        const viewWidth = width;
        const viewHeight = height;
        let scaleRate = viewWidth / image.value.naturalWidth;
        let scaleWidth = viewWidth;
        let scaleHeight = image.value.naturalHeight * scaleRate;
        if (scaleHeight > viewHeight) {
          scaleRate = viewHeight / image.value.naturalHeight;
          scaleWidth = image.value.naturalWidth * scaleRate;
          scaleHeight = viewHeight;
        }
        NativeClient.sendDebugLog(
          "PantryInferenceImageZoomPage drawImageData loaded scaleWidth=" +
            scaleWidth +
            " scaleHeight=" +
            scaleHeight
        );
        image.value.style.width = scaleWidth + "px";
        image.value.style.height = scaleHeight + "px";
        NativeClient.sendDebugLog("PantryInferenceImageZoomPage drawImageData window.innerWidth=" + window.innerWidth + " window.innerHeight=" + window.innerHeight);
        NativeClient.sendDebugLog("PantryInferenceImageZoomPage drawImageData scaleWidth=" + scaleWidth + " window.innerHeight=" + scaleHeight);
      }
    };

    const requestLoadImage = async () => {
      const requst = new LoadPantryCameraImage(fileName);
      await Promise.all([NativeClient.loadPantryCameraImage(requst)]).then(result => {
        const imageResult = store.getters["common/getPantryCameraImage"];
        if (imageResult != null) {
          NativeClient.sendDebugLog("PantryInferenceImageZoomPage drawScreenDrawImage imageResult=" + JSON.stringify(imageResult));
          if (imageResult.imageData) {
            setImage(imageResult.imageData, width.value, height.value);
          }
        }
      }).catch(error => {
          NativeClient.sendDebugLog("PantryInferenceImageZoomPage requestLoadImage error " + JSON.stringify(error));
          NativeClient.showCameraCloseButton(false);
      });
    };

    /*
     * レシピ詳細の取得を実行する
     */
    const execute = async () => {
      requestLoadImage();
    };

    const closeError = () => {
      closeDialog();
      NativeClient.showCameraCloseButton(true);
    };

    /**
     * コンポーネントがマウントされたときに通知される
     */
    onMounted(() => {
      NativeClient.sendDebugLog("ImagePage onMounted");
      width.value = window.innerWidth;
      height.value = window.innerHeight;
      execute();
    });
    return {
      handleApiError,
      getApiErrorTitle,
      getApiErrorMessage,
      image,
      useApiErrorDialog,
      closeDialog,
      closeError,
      ERROR_BUTTON_LABEL
    };
  }
});
